import React, {Fragment} from "react";
// import {List, Loader} from "semantic-ui-react";
// import {FormattedMessage} from "react-intl";

export const Tags = ({}) => {

    // const [tags, setTags] = useState([]);
    // const [isLoading, setIsLoading] = useState(false);

    return (
        <Fragment>
            {/*<h3 className="ui header"><FormattedMessage id="Tags"/></h3>*/}

            {/*<List>*/}
            {/*    <Loader*/}
            {/*        active={isLoading}*/}
            {/*        inline={true}*/}
            {/*    />*/}
            {/*    {*/}
            {/*        tags.map((tag) => {*/}
            {/*            return (*/}
            {/*                <div>*/}
            {/*                    {tag.name}*/}
            {/*                </div>*/}
            {/*            );*/}
            {/*        })*/}
            {/*    }*/}
            {/*</List>*/}
        </Fragment>
    );
};

